var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"over"},[_vm._v("\n  本平台于2023年9月28日晚22点起 - 2023年10月7日早上9点止关闭（10月7日早上9点开启）\n  请耐心等待。。。\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }